// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile:
      (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
  $('#wrapper').addClass('setTouch');
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
// $(function () {
//   // setScroll();
//   // if ($('#wrapper').hasClass('home')) {
//   //   setWave();
//   // }
//   // ///////////
//   // if (!_ua.Mobile && !_ua.Tablet) {
//   //   $('#wrapper').addClass('desktop');
//   //   if (!$('#wrapper').hasClass('about')) {
//   //     $('html, body').prop({
//   //       scrollTop: 0,
//   //     });
//   //     if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
//   //       // ここにSafari用の記述
//   //     } else {
//   //     }
//   //   }
//   // }
//   // ///////////
// });

$(window).on('load', function () {
  judgeWinSize();
  setHeader();
  setSpan();
  // setInview();
  setAcc();
  // setMegaMenu();
  startScroll();
  setMainMenu();
  setLoaded();
  setScrollTop();
  if ($('#wrapper').hasClass('home')) {
    // switchMovie();
    // setKv();
    setSlider_01();
    setSchedule();
    // switchMovie();
    fvShuffle();
  } else if ($('#wrapper').hasClass('about')) {
    // switchMovie();
    // setKv();
    setSlider_02();
  } else if ($('#wrapper').hasClass('schedule')) {
    setSchedule();
    scheduleAcc();
  } else if ($('#wrapper').hasClass('contact')) {
    setMailTo();
    // setForm();
  }
  setSoundBtn();
  // shuffleTx();
  setWay();
  setGlitchClass();
});

var current_scrollY = 0;

// ///////TOPボタン
function setScrollTop() {
  const baseHeight = 10;
  const footH = $('footer').height();
  fixedToTop();

  $(window).scroll(function () {
    fixedToTop();
  });

  function fixedToTop() {
    var scrollHeight = $(document).height() - footH;
    if ($(this).scrollTop() <= baseHeight) {
      $('#scrollTop').removeClass('active');
    } else if ($(this).scrollTop() > baseHeight) {
      $('#scrollTop').addClass('active');
    }
    if ($(window).height() + $(this).scrollTop() >= scrollHeight) {
      $('#scrollTop').addClass('footPos');
    } else {
      $('#scrollTop').removeClass('footPos');
    }
  }
}

//mailto SPAM対策
function setMailTo() {
  $('.mto').click(function () {
    var address = $(this).attr('href').replace('+', '@');
    location.href = 'mailto:' + address;
    return false;
  });
}

// /////フォーム制御
function setForm() {
  $('.wpcf7-tel').attr('pattern', '\\d*');
  $('.wpcf7-tel').attr(
    'onkeyup',
    'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")'
  );

  $('input[name="acceptance-form"]').change(function () {
    var prop = $(this).prop('checked');
    if (prop) {
      $('#confirmBtn').removeClass('off');
    } else {
      $('#confirmBtn').addClass('off');
    }
  });

  $('#confirmBtn').on('click', function () {
    $('.wpcf7c-btn-confirm').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7c-btn-back').click();
  });
  $('#submitBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  // /////エラーのとき
  document.addEventListener(
    'wpcf7invalid',
    function (event) {
      setTimeout(function () {
        var position = $('.wpcf7-not-valid-tip:first').offset().top - 300;
        $('html,body').animate(
          {
            scrollTop: position,
          },
          {
            queue: false,
          }
        );
      }, 100);
    },
    false
  );
  // /////成功のとき
  document.addEventListener(
    'wpcf7mailsent',
    function (event) {
      $('html,body').animate(
        {
          scrollTop: 0,
        },
        {
          queue: false,
        }
      );
    },
    false
  );

  // var urlHash = location.search;
  // // URLにアンカーが存在する場合
  // if (urlHash) {
  //   urlHash = urlHash.replace('?subject_', '');
  //   var target = '.subjectSelect .wpcf7-list-item:nth-child(' + urlHash + ') label';
  //   target = $(target);
  //   target.click();
  // }
}

// ///////////////////////////フォーム確認画面
function setConfirm() {
  const tx1 = $('input:checkbox[name="subject"]:checked').val();
  $('#subjectTx').val(tx1);

  const tx2 = $('[name=myname]').val();
  $('#myname').val(tx2);

  const tx3 = $('[name=company]').val();
  $('#company').val(tx3);

  const tx4 = $('[name=mytel]').val();
  $('#mytel').val(tx4);

  const tx5 = $('[name=mymail]').val();
  $('#mymail').val(tx5);

  const tx6 = $('[name=content]').val();
  $('#contentTx').val(tx6);
}

// ファーストビューシャッフルテキスト
function fvShuffle() {
  const arr = [];
  $('.yearLabel .labelTx').each(function (i) {
    arr[i] = new ShuffleText(this);
  });
  shuffleStart();

  function shuffleStart() {
    $('.yearLabel .labelTx').each(function (i) {
      if (!$(this).hasClass('endAnime')) {
        arr[i].start(); //配列で登録テキストのアニメーションをおこなう
        arr[i].duration = 800; //テキストが最終変化するまでの時間※規定値600
        $(this).addClass('endAnime'); //１度アニメーションした場合はendAnimeクラスを追加
      }
    });
  }
}

// スケジュール
function setSchedule() {
  $('.scheduleList .head').on('click', function () {
    $(this).parents('.item').toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });

  $('.scheduleList .score').each(function () {
    const homeScore = $(this).find('.home').text();
    const awayScore = $(this).find('.away').text();
    const judge = $(this).parents('.item').find('.judgeList');
    if (homeScore > awayScore) {
      $(this).find('.home').addClass('style_01');
      judge.find('.styleAway').addClass('style_01');
    } else if (homeScore < awayScore) {
      $(this).find('.away').addClass('style_01');
      judge.find('.styleHome').addClass('style_01');
    }
  });
}

//glitchアニメーショントリガークラス
function setGlitchClass() {
  $('.glitchLink').hover(
    function () {
      if ($('#wrapper').hasClass('setPc')) {
        $(this).stop().addClass('glitchStart');
      }
    },
    function () {
      if ($('#wrapper').hasClass('setPc')) {
        $(this).stop().removeClass('glitchStart');
      }
    }
  );
}

//スライダー
function setSlider_01() {
  const mySwiperMain = new Swiper('.carouselStyle_01 .swiper-main', {
    // init: false,
    direction: 'vertical',
    slidesPerView: 1,
    watchSlidesProgress: true,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    on: {
      init: function () {
        $('.carouselStyle_01 .swiper-main').addClass('swiper-ready');
      },
      // slideChangeTransitionStart: function () {
      //   if ($('#wrapper').hasClass('setSp')) {
      //     shuffleTx_02();
      //   }
      // },
      transitionEnd: function () {
        // if ($('#wrapper').hasClass('setPc')) {
        //   shuffleTx_02();
        // }
        const activeIndex = this.activeIndex;
        const activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
        $('.carouselStyle_01 .glitchLink').removeClass('glitchStart');
        $(activeSlide).find('.glitchLink').addClass('glitchStart');
        $(activeSlide).next().find('.glitchLink').addClass('glitchStart');
        timer = setTimeout(function () {
          $('.carouselStyle_01 .glitchLink').removeClass('glitchStart');
        }, 100);
      },
    },
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      769: {
        slidesPerView: 2,
        direction: 'horizontal',
        spaceBetween: 20,
      },
    },
    // on: {
    //   init: function () {
    //     const activeIndex = this.activeIndex;
    //     const activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
    //     const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
    //     activeSlideVideo.play();
    //   },
    //   //スライダー遷移時（ドキュメント内の全動画を一時停止にする）
    //   transitionStart: function () {
    //     const videos = document.querySelectorAll('video');

    //     Array.prototype.forEach.call(videos, function (video) {
    //       video.pause();
    //     });
    //   },
    //   //スライダー遷移完了後（アクティブスライドの動画を再生する）
    //   transitionEnd: function () {
    //     const activeIndex = this.activeIndex;
    //     const activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
    //     const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
    //     if (activeSlideVideo) {
    //       activeSlideVideo.play();
    //     }
    //   },
    // },
  });
}

function setSlider_02() {
  const mySwiperMain = new Swiper('.carouselStyle_02 .swiper-main', {
    // init: false,
    slidesPerView: 1,
    allowTouchMove: true,
    loop: true,
    watchSlidesProgress: true,
    effect: 'fade',
    speed: 200,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    on: {
      init: function () {
        $('.carouselStyle_02 .swiper-main').addClass('swiper-ready');
      },
      transitionEnd: function () {
        const activeIndex = this.activeIndex;
        const activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
        console.log(activeIndex);
        $('.carouselStyle_02 .glitchImg').removeClass('glitchStart');
        $(activeSlide).find('.glitchImg').addClass('glitchStart');
        $(activeSlide).next().find('.glitchImg').addClass('glitchStart');
        timer = setTimeout(function () {
          $('.carouselStyle_02 .glitchImg').removeClass('glitchStart');
        }, 100);
      },
    },
  });
}

//シャッフルテキスト
function shuffleTx_01(target) {
  const targetDom = target.get(0);
  const shuffleTx = new ShuffleText(targetDom); //動作させるテキストを配列に格納
  if (!target.hasClass('endAnime')) {
    shuffleTx.start(); //配列で登録テキストのアニメーションをおこなう
    shuffleTx.duration = 800; //テキストが最終変化するまでの時間※規定値600
    target.addClass('endAnime'); //１度アニメーションした場合はendAnimeクラスを追加
  }
}
function shuffleTx_02(target) {
  const arr = [];
  $('.carouselStyle_01 .swiper-slide-visible .shuffleTx').each(function (i) {
    arr[i] = new ShuffleText(this);
  });
  shuffleStart();

  function shuffleStart() {
    $('.carouselStyle_01 .swiper-slide-visible .shuffleTx').each(function (i) {
      arr[i].start(); //配列で登録テキストのアニメーションをおこなう
      arr[i].duration = 800; //テキストが最終変化するまでの時間※規定値600
    });
  }
}

//Menuシャッフル
function typingMenu() {
  const arr = [];
  $('.navGlobal .labelTx').each(function (i) {
    arr[i] = new ShuffleText(this);
  });
  menuStart();

  function menuStart() {
    $('.navGlobal .labelTx').each(function (i) {
      if (!$(this).hasClass('endAnime')) {
        arr[i].start(); //配列で登録テキストのアニメーションをおこなう
        arr[i].duration = 800; //テキストが最終変化するまでの時間※規定値600
        // $(this).addClass('endAnime'); //１度アニメーションした場合はendAnimeクラスを追加
      }
    });
  }
}

//動画のスマホ切り替え
function switchMovie() {
  // 切り替える対象にclass属性。
  var $elem = $('.switch');

  // 切り替えの対象のsrc属性の末尾の文字列。
  var sp = '_sp.';
  var pc = '_pc.';

  // 画像を切り替えるウィンドウサイズ。
  var replaceWidth = 768;

  function imageSwitch() {
    // ウィンドウサイズを取得する。
    var windowWidth = parseInt($(window).width());

    // ページ内にあるすべての`.switch`に適応される。
    $elem.each(function () {
      var $this = $(this);
      var $poster = $(this).parent();
      // ウィンドウサイズが768px以上であれば_spを_pcに置換する。
      if (windowWidth > replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));
        if ($(this).parents('.videoSec').hasClass('video-way')) {
          $poster.attr('poster', $poster.attr('poster').replace(sp, pc));
        }

        // ウィンドウサイズが768px未満であれば_pcを_spに置換する。
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
        if ($(this).parents('.videoSec').hasClass('video-way')) {
          $poster.attr('poster', $poster.attr('poster').replace(pc, sp));
        }
      }
      const myvideo = $(this).parent().get(0);
      myvideo.load();
      if ($(this).parent().hasClass('kvVideo')) {
        timer = setTimeout(function () {
          myvideo.play();
        }, 100);
      }
    });
  }
  imageSwitch();

  // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    } else {
      currentWidth = window.innerWidth;
      if (timer !== false) {
        clearInterval(timer);
      }
      timer = setTimeout(function () {
        imageSwitch();
      }, 200);
    }
  });
}

//KV動画
function setKv() {
  const videoElem = document.getElementById('video');
  videoElem.addEventListener('loadedmetadata', function () {
    $('#kvVideo video').get(0).play();
    $('#mainVis').addClass('ready');
    timer = setTimeout(function () {
      $('#kvVideo').addClass('active');
    }, 600);
  });

  // if ($('#wrapper').hasClass('home')) {
  //   const currentTimeText = document.getElementById('currentTime');
  //   videoElem.addEventListener('timeupdate', () => {
  //     const currentTime = videoElem.currentTime;
  //     const minutes = Math.floor(currentTime / 60);
  //     const seconds = Math.floor(currentTime % 60);
  //     // seconds = seconds < 10 ? '0' : '';
  //     // const currentTimeString = `${minutes}<span>:</span>${seconds < 10 ? '0' : ''}${seconds}`;
  //     $('#currentTime .minutes').html(minutes);
  //     if (seconds < 10) {
  //       const secondsTx = '0' + String(seconds);
  //       $('#currentTime .seconds').html(secondsTx);
  //     } else {
  //       $('#currentTime .seconds').html(seconds);
  //     }
  //   });
  // }
}

var allMute = true;
//サウンドボタン
// function setSoundBtn() {
//   $('.soundCtr').on('click', function () {
//     const video = $(this).parents('.videoSec').find('video').get(0);
//     if ($(this).hasClass('soundOff')) {
//       $('.video').each(function () {
//         const allVideo = $(this).get(0);
//         // $('.soundCtr').addClass('soundOff');
//         allVideo.muted = true;
//       });
//       $('.soundCtr').removeClass('soundOff');
//       // $(this).removeClass('soundOff');
//       video.muted = false;
//       allMute = false;
//     } else {
//       $('.soundCtr').addClass('soundOff');
//       // $(this).addClass('soundOff');
//       $('.video').each(function () {
//         const allVideo = $(this).get(0);
//         allVideo.muted = true;
//       });
//       allMute = true;
//     }
//   });
// }
function setSoundBtn() {
  $('.soundCtr').on('click', function () {
    const video = $(this).parents('.videoSec').find('video').get(0);
    if ($(this).hasClass('soundOff')) {
      $('.video').each(function () {
        const allVideo = $(this).get(0);
        $('.soundCtr').addClass('soundOff');
        allVideo.muted = true;
      });
      $(this).removeClass('soundOff');
      video.muted = false;
    } else {
      $(this).addClass('soundOff');
      video.muted = true;
    }
  });
}

// //////////////////////////メインメニュー
function setMainMenu() {
  $('#mainMenu').on('click', function () {
    if (!$('#mainMenu').hasClass('active')) {
      typingMenu();
      openFnc();
    } else {
      closeFnc();
    }
  });
  $('#clickBlocker,#menuPanel .closeBtn,#menuPanel .closeArea,#menuPanel .mainNav').on(
    'click',
    function (event) {
      event.stopPropagation();
      closeFnc();
    }
  );

  // $('.mainNav a').on('click', function (event) {
  //   event.stopPropagation();
  // });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearInterval(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });
}

function openFnc() {
  current_scrollY = $(window).scrollTop();
  $('#mainMenu').addClass('active');
  $('#wrapper').addClass('menuOpen');
  if ($('#wrapper').hasClass('setSp')) {
    $('#outerMenu').css('top', -current_scrollY);
  }
}

function closeFnc() {
  $('#mainMenu').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  if ($('#wrapper').hasClass('setSp')) {
    $('html, body').prop({
      scrollTop: current_scrollY,
    });
  }
}

var firstScroll = true;
// ///////ヘッダー制御
function setHeader() {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
      $('header').removeClass('fixedHeaderDelay');
    }, 10);
  });

  fixedHeader();
  // console.log($('#mainVis').height())

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader() {
    if ($('#wrapper').hasClass('home')) {
      h = $('#mainVis').height() - 50;
      // var video2Pos = $('#video_02').offset().top;
    } else if ($('#wrapper').hasClass('setKv')) {
      h = $('#kv').height();
    } else {
      h = 5;
    }
    baseHeight = h;
    if ($(this).scrollTop() < baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
      // if ($('#wrapper').hasClass('home') && firstScroll == false) {
      //   const videoElem = $('#kvVideo').find('video');
      //   $('.video').each(function () {
      //     const allVideo = $(this).get(0);
      //     allVideo.pause();
      //     // allVideo.muted = true;
      //     if (allMute == true) {
      //       videoElem.get(0).muted = true;
      //     } else {
      //       videoElem.get(0).muted = false;
      //     }
      //   });
      //   videoElem.get(0).play();
      // }
    } else if ($(this).scrollTop() >= baseHeight) {
      $('#wrapper').addClass('fixedHeader');
      firstScroll = false;
    }
    // if ($(this).scrollTop() > video2Pos) {
    //   if ($('#wrapper').hasClass('home')) {
    //     const allVideo = $('#video').get(0);
    //     $('#video .soundCtr').addClass('soundOff');
    //     allVideo.muted = true;
    //   }
    // }
  }
}

// テキストアニメーション用span生成
function setSpan() {
  $('.txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

// ///////waypoint
function setWay() {
  $('.way,.way-slow,.alphaWay,.js-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.mind-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after2');
        }, 600);
        timer = setTimeout(function () {
          activePoint.addClass('is-active-delay');
        }, 1200);
        timer = setTimeout(function () {
          activePoint.addClass('is-active-delay2');
        }, 1300);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.foot-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '95%',
    }
  );
  $('.js-item-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active-item');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-item-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  // $('.video-way').waypoint(
  //   function (direction) {
  //     var activePoint = $(this.element);
  //     var videoElem = activePoint.find('video');
  //     if (direction === 'down') {
  //       $('.video').each(function () {
  //         const allVideo = $(this).get(0);
  //         allVideo.pause();
  //         // allVideo.muted = true;
  //         if (allMute == true) {
  //           videoElem.get(0).muted = true;
  //         } else {
  //           videoElem.get(0).muted = false;
  //         }
  //       });
  //       videoElem.get(0).play();
  //     }
  //   },
  //   {
  //     offset: '70%',
  //   }
  // );
  $('.video-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      var videoElem = activePoint.find('video');
      if (direction === 'down') {
        videoElem.get(0).play();
        // $('.video').each(function () {
        //   const allVideo = $(this).get(0);
        //   $('.soundCtr').addClass('soundOff');
        //   allVideo.muted = true;
        // });
      }
    },
    {
      offset: '70%',
    }
  );
  $('.shuffle-way').waypoint(
    function (direction) {
      var activePoint = $(this.element).find('.shuffleTx');
      if (direction === 'down') {
        // scroll down
        shuffleTx_01(activePoint);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.glitch-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        activePoint.addClass('glitchStart');
        timer = setTimeout(function () {
          activePoint.removeClass('glitchStart');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.glitch-way-infinite').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        activePoint.addClass('glitchStart');
      }
    },
    {
      offset: '70%',
    }
  );
  $('.glitch-way-infinite-delay_01').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        timer = setTimeout(function () {
          activePoint.addClass('glitchStart');
        }, 800);
      }
    },
    {
      offset: '70%',
    }
  );
}

// ////////////////////////////アコーディオン
function setAcc() {
  $('.js-toggle .js-ttl').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
  $('.navGlobal .hasChild .toggle').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
}

function scheduleAcc() {
  $('.scheduleNav li').on('click', function () {
    if (!$(this).hasClass('active')) {
      const target = '#' + $(this).data('cont');
      const targetLabel = $(this).data('label');
      $('.scheduleNav li').removeClass('active');
      $('.tabSchedule').removeClass('active');
      $(this).addClass('active');
      $(target).addClass('active');
      $('.scheduleTtl span').text(targetLabel);
      $('.scheduleTtl span').removeClass('endAnime');
      shuffleTx_01($('.scheduleTtl span'));
    }
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $('#wrapper,#loading').addClass('loaded');
  loadStart();
}

function loadStart() {
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedDone');
  }, 200);
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedStart');
  }, 600);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
  }, 1500);
  timer = setTimeout(function () {
    $('#wrapper').addClass('homeStart');
  }, 1200);
  if ($('#wrapper').hasClass('home')) {
    timer = setTimeout(function () {
      $('#wrapper').addClass('homeDelay');
    }, 2200);
  } else {
    timer = setTimeout(function () {
      $('#wrapper').addClass('pagesDelay');
    }, 500);
  }
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// /////////////////////////////スムーススクロール
function setScroll() {
  var headerHeight = $('header').height();
  // var headerHeight = $('header .col-main').height() + 50;
  // if ($('#wrapper').hasClass('setPc')) {
  //   var headerHeight = 0;
  // } else {
  //   var headerHeight = 100;
  // }
  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    // var position = target.offset().top;

    if ($(this).hasClass('unqNav')) {
      closeFnc();
    }
    setTimeout(function () {
      var position = target.offset().top - headerHeight;
      $('html, body').animate(
        {
          scrollTop: position,
        },
        400,
        'swing'
      );
    }, 100);
    e.preventDefault();
    // $.when(
    //   $('html, body').animate(
    //     {
    //       scrollTop: position,
    //     },
    //     400,
    //     'swing'
    //   ),
    //   e.preventDefault()
    // ).done(function () {
    //   var diff = target.offset().top;
    //   if (diff === position) {
    //   } else {
    //     $('html, body').animate(
    //       {
    //         scrollTop: diff,
    //       },
    //       400,
    //       'swing'
    //     );
    //   }
    // });
  });
}

function startScroll() {
  // ページのURLを取得
  const url = $(location).attr('href'),
    // headerの高さを取得してそれに30px追加した値をheaderHeightに代入
    headerHeight = $('header').outerHeight() + 30;

  // urlに「#」が含まれていれば
  if (url.indexOf('#') != -1) {
    // urlを#で分割して配列に格納
    const anchor = url.split('#'),
      // 分割した最後の文字列（#◯◯の部分）をtargetに代入
      target = $('#' + anchor[anchor.length - 1]),
      // リンク先の位置からheaderHeightの高さを引いた値をpositionに代入
      position = Math.floor(target.offset().top) - headerHeight;
    // positionの位置に移動
    $('html, body').animate({ scrollTop: position }, 500);
  }
  setScroll();
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}
